<div class="lua-radio-button" [ngClass]="classes">
	<mat-radio-button class="custom-radio" [name]="nameGroupe" [disabled]="disabled" [checked]="checked" disableRipple>
	</mat-radio-button>

	<ng-container *ngIf="label !== ''">
		<p class="label" *ngIf="label && !checked">{{ label }}</p>
		<p class="label-checked" *ngIf="label && checked">{{ label }}</p>
	</ng-container>
</div>